// Token Governance - small shared pieces for the Budgets, Enforcement,
// Forecast, Policies and Alerts pages.  G360_K561
//
// RankHead is the colour-headed top of every ranked drawer, in the same
// design as the Vendor and Overview drawers: what it is, its rank, one big
// figure and what the figure means.
export function RankHead({ color, kicker, title, sub, big, bigSub, mark, testid }) {
  return (
    <div data-testid={testid || 'rank-head'} style={{ display: 'flex', gap: 14, alignItems: 'center', padding: 16, borderRadius: 'var(--g-r-lg)', border: '1px solid var(--g-divider)', borderTop: '3px solid ' + color, background: 'linear-gradient(135deg, var(--g-bg-alt), var(--g-surface) 72%)' }}>
      {mark}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: 'var(--g-text-3)' }}>{kicker}</div>
        <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--g-ink, #202124)', marginTop: 2, wordBreak: 'break-word' }}>{title}</div>
        {sub && <div style={{ fontSize: 12, color: 'var(--g-text-2)', marginTop: 2, lineHeight: 1.45 }}>{sub}</div>}
      </div>
      {big != null && (
        <div style={{ textAlign: 'center', minWidth: 90 }}>
          <div style={{ fontFamily: 'var(--g-font-display)', fontSize: 28, fontWeight: 700, color, lineHeight: 1 }}>{big}</div>
          {bigSub && <div style={{ fontSize: 11, color: 'var(--g-text-2)', marginTop: 4 }}>{bigSub}</div>}
        </div>
      )}
    </div>
  );
}

export function Pill({ color, bg, children, title, testid }) {
  return <span className="pill" data-testid={testid} title={title} style={{ background: bg || 'var(--g-bg-alt)', color: color || 'var(--g-text-2)', fontWeight: 600, fontSize: 11 }}>{children}</span>;
}

export function Empty({ children }) {
  return <p style={{ fontSize: 13, color: 'var(--g-text-2)', margin: 0 }}>{children}</p>;
}

export function ReadFail({ what, err, onRetry }) {
  return (
    <div className="banner danger" style={{ flexWrap: 'wrap', marginBottom: 12 }}>
      <span>{what} could not be read ({(err && err.message) || String(err || 'the read failed')}). This is not the same as there being none.</span>
      {onRetry && <button className="btn outline" style={{ marginLeft: 'auto', height: 28 }} onClick={onRetry}>Retry</button>}
    </div>
  );
}

export function NotOn({ what }) {
  return (
    <div className="card" data-testid="not-switched-on" style={{ padding: '16px 18px', borderLeft: '3px solid var(--g-warning)' }}>
      <p className="metric-l" style={{ color: 'var(--g-warning)', margin: 0 }}>{what} is not switched on for this organisation yet</p>
      <p style={{ fontSize: 13, color: 'var(--g-text-2)', margin: '6px 0 0' }}>The other Token Governance tabs work as before.</p>
    </div>
  );
}

export const usd = (v, dp) => {
  const x = Number(v || 0);
  if (Math.abs(x) >= 1e6) return '$' + (x / 1e6).toFixed(2) + 'M';
  if (Math.abs(x) >= 1e4) return '$' + (x / 1e3).toFixed(1) + 'K';
  return '$' + x.toLocaleString('en-US', { minimumFractionDigits: dp == null ? 2 : dp, maximumFractionDigits: dp == null ? 2 : dp });
};
export const pct = (v) => (v == null || !isFinite(v) ? '-' : Math.round(100 * v) + '%');
export const when = (iso) => (iso ? new Date(iso).toLocaleString() : '-');
export const short = (iso) => (iso ? new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-');
export const day = (iso) => (iso ? new Date(String(iso).length === 10 ? iso + 'T00:00:00Z' : iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }) : '-');
